import { useState, useCallback } from "react"

export function useToggle(initialState = false) {
  const [opened, setOpened] = useState(initialState)

  const open = useCallback(function open() {
    setOpened(true)
  }, [])

  const close = useCallback(function close() {
    setOpened(false)
  }, [])

  const toggleOpen = useCallback(function toggle() {
    setOpened((state) => !state)
  }, [])

  return {
    opened,
    open,
    close,
    toggleOpen,
    setOpened,
  }
}
